<div class="flex flex-row md:flex-col bg-white p-6 rounded-lg">

  <ng-container *ngTemplateOutlet="data.descriptionTemplateRef;context:data"></ng-container>

</div>

